import styled from "styled-components";
import { Skeleton } from "../skeleton/Skeleton.styles";

export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  cursor: ${(props) => (props.$cursorPointer ? "pointer" : "auto")};
`;

export const SkeletonContainer = styled(Skeleton)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
`;

/* Video sits over the poster image and fades in when loaded. Keeping
   it absolute means the poster stays in place underneath, so toggling
   src on/off doesn't flash an empty card. */
export const VideoComponent = styled.video`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 180ms ease;
`;

/* Poster is always rendered behind the video. Opacity is driven by the
   parent (gated on onLoad) so the broken-image glyph never shows during
   the load window — until bytes arrive, the card's own gradient shows
   through. No filter — the previous 8px blur made every poster look
   "soft" until the video kicked in, which read as a flicker during scroll. */
export const Image = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 220ms ease;
`;
